import { Breadcrumbs } from "components/Common/Common";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

import styles from './profile.module.scss';
import { Formik } from "formik";
import { useState } from "react";
import { useChangePasswordMutation } from "store/services/auth";
import { successMessageToast } from "helpers/common";
import AppInputFieldV2 from "components/Common/AppInputFIeldV2";
import { Eye, EyeOff } from "react-feather";
import LoadingButton from "../LoadingButton";
import changePasswordSchema from "./password.schema";
import { useNavigate } from "react-router-dom";
import { PROFILE } from "config/paths";

const ChangePassword = () => {

    const navigate = useNavigate()

    const initialValues = {
        current_password: "",
        new_password: "",
        confirm_password: ""
    }

    const [showPassword, setShowPassword] = useState({ current_password: false, new_password: false, confirm_password: false })

    const [changePassword, { isLoading: changePasswordLoading }] = useChangePasswordMutation();

    const handleSubmit = async (values) => {
        const body = {
            current_password: values?.current_password,
            new_password: values?.new_password
        }
        try {
            const result = await changePassword({ data: body }).unwrap();
            successMessageToast(result?.message);
            navigate(PROFILE)
        } catch (err) { console.log("Error updating profile", err); }
    };



    return (
        <>
            <div className="px-3 py-2">
                <Breadcrumbs items={[{ label: "Profile", path: "/profile" }, { label: "Change Password", path: "" }]} style={{ fontSize: "14px" }} />

                <section className={`${styles.addForm} position-relative col-lg-10 addForm`}>
                    <Container fluid={true}>
                        <Row>

                            <Col lg="12" className="my-2 px-0 ">
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={changePasswordSchema}
                                    onSubmit={handleSubmit}
                                    enableReinitialize
                                >
                                    {({
                                        handleSubmit,
                                    }) => (
                                        <Form onSubmit={handleSubmit}>
                                            <Col lg="12" className="my-2">
                                                <div style={{ borderBottom: '0.75px solid #93278F', paddingBottom: "11px" }} className=' d-flex align-items-end justify-content-between'>
                                                    <h5 className='section-title-main fw-medium border-0 m-0 p-0'>Change Password</h5>
                                                    <LoadingButton type="submit" isLoading={changePasswordLoading} className="discharge-screen">{'Save Changes'}  </LoadingButton>
                                                </div>
                                            </Col>
                                            <div>
                                                <div>
                                                    {/* <h5 className="section-title">CHANGE PASSWORD</h5> */}
                                                    <div className="d-flex flex-column gap-4 pe-md-4">
                                                        <Row>
                                                            <Row>
                                                                <Col md="6" className="mb-3">
                                                                    <label className="discharge-screen-label">Current Password*</label>
                                                                    <div className="position-relative iconWithText">
                                                                        <AppInputFieldV2
                                                                            name="current_password"
                                                                            type={showPassword?.current_password ? "text" : "password"}
                                                                            placeholder=""
                                                                            className={`readonly-box`}
                                                                        />
                                                                        <Button
                                                                            onClick={() => setShowPassword((prev) => ({ ...prev, current_password: !prev?.current_password }))}
                                                                            className="border-0 p-0 position-absolute icn"
                                                                            variant="transparent"
                                                                            style={{ right: 10, top:20 }}
                                                                        >
                                                                            {showPassword?.current_password ? <EyeOff size={18} color="#595959" /> : <Eye size={18} color="#595959" />}
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                                {/* <Col lg="12" className="my-2">
                                                                    <div className="position-relative iconWithText">
                                                                        <AppInputField
                                                                            name="password"
                                                                            type={showPassword ? "text" : "password"}
                                                                            placeholder="Password"
                                                                            className={`${styles.formControl} form-control`}
                                                                        />
                                                                        <Button
                                                                            onClick={() => setShowPassword(!showPassword)}
                                                                            className="border-0 p-0 position-absolute icn"
                                                                            variant="transparent"
                                                                            style={{ right: 10 }}
                                                                        >
                                                                            {showPassword ? <EyeOff size={18} color="#595959" /> : <Eye size={18} color="#595959" />}
                                                                        </Button>
                                                                    </div>
                                                                </Col> */}
                                                            </Row>
                                                            <Row>
                                                                <Col md="6" className="mb-3">
                                                                    <label className="discharge-screen-label">New Password*</label>
                                                                    <div className="position-relative iconWithText">

                                                                        <AppInputFieldV2
                                                                            name="new_password"
                                                                            type={showPassword?.new_password ? "text" : "password"}
                                                                            placeholder=""
                                                                            className={`readonly-box`}
                                                                        />
                                                                        <Button
                                                                            onClick={() => setShowPassword((prev) => ({ ...prev, new_password: !prev?.new_password }))}
                                                                            className="border-0 p-0 position-absolute icn"
                                                                            variant="transparent"
                                                                            style={{ right: 10,  top:20  }}
                                                                        >
                                                                            {showPassword?.new_password ? <EyeOff size={18} color="#595959" /> : <Eye size={18} color="#595959" />}
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md="6" className="mb-3">
                                                                    <label className="discharge-screen-label">Confirm Password*</label>
                                                                    <div className="position-relative iconWithText">

                                                                        <AppInputFieldV2
                                                                            name="confirm_password"
                                                                            type={showPassword?.confirm_password ? "text" : "password"}
                                                                            placeholder=""
                                                                            className={`readonly-box`}
                                                                        />
                                                                        <Button
                                                                            onClick={() => setShowPassword((prev) => ({ ...prev, confirm_password: !prev?.confirm_password }))}
                                                                            className="border-0 p-0 position-absolute icn"
                                                                            variant="transparent"
                                                                            style={{ right: 10,  top:20  }}
                                                                        >
                                                                            {showPassword?.confirm_password ? <EyeOff size={18} color="#595959" /> : <Eye size={18} color="#595959" />}
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        </>
    );
};

export default ChangePassword;